import '../resume/Resume'
import {
    Container, Row, Col, Button
} from 'reactstrap';

const Skills = () => {
    return (
        <Container className='resume-container' id='resume'>
            <h3 className='title'>MON SAVOIR FAIRE</h3>
            <Row style={{paddingTop:'10px'}}>
                <Col lg={6} md={6} className='col-edu'>
                    <div className='main-div'>
                        <div>
                            <div className='div-point'>
                                <div><span className='point'></span></div>
                                <h4 className='point-title'>Backend</h4>
                            </div>
                            <div className='content' style={{paddingTop:'30px'}}>
                                <div>
                                    <p> 
                                        Je conçois et développe des solutions web sur mesure, performantes et sécurisées. 
                                        J’intègre la logique métier, gère les accès utilisateurs et mets en place des architectures solides, prêtes pour la montée en charge et le déploiement automatisé.
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div>
                            <div className='div-point2'>
                                <div><span className='point'></span></div>
                                <h4 className='point-title'>Data</h4>
                            </div>
                            <div className='content'>
                                <div>
                                    <p>
                                        Je conçois, modélise et optimise des bases de données afin de garantir la fiabilité, la performance et la cohérence des informations. 
                                        Je mets également en place des pipelines ETL pour automatiser le traitement et l’exploitation des données.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </Col>

                <Col lg={6} md={6} className='col-exp'>
                    <div className='main-div'>
                        <div>
                            <div className='div-point'>
                                <div><span className='point'></span></div>
                                <h4 className='point-title'>Frontend</h4>
                            </div>
                            <div className='content' style={{paddingTop:'30px'}}>
                                <div>
                                    <p> 
                                        Je crée des interfaces modernes, intuitives et responsives, centrées sur l’expérience utilisateur. 
                                        J’intègre les API et développe des dashboards dynamiques et des composants réutilisables pour des interfaces fluides et évolutives.
                                    </p>
                                </div>
                            </div>
                        </div>

                        <div>
                            <div className='div-point2'>
                                <div><span className='point'></span></div>
                                <h4 className='point-title'>Automatisation, tests, IA</h4>
                            </div>
                            <div className='content'>
                                <div>
                                    <p>
                                        J’automatise les processus de développement et de déploiement via des pipelines CI/CD. J’intègre des tests unitaires, 
                                        d’intégration et e2e pour assurer la qualité. J’exploite aussi l’intelligence artificielle et les outils d’automatisation 
                                        pour améliorer la productivité et la fiabilité des applications.
                                    </p>
                                </div>
                            </div>
                        </div>

                    </div>
                </Col>
            </Row>
        </Container>
    );
}

export default Skills;